export const DIALOG_RESULT_RETRIEVED = "retrieved";
export const DIALOG_RESULT_CANCEL = "cancel";
export const DIALOG_RESULT_OK = 'ok';